export interface NextStepContext {
  reference: string;
  title: string;
}

export const nextStepContexts: NextStepContext[] = [
  {
    reference: 'lead',
    title: 'Leads',
  },
  {
    reference: 'opportunity',
    title: 'Opportunities',
  },
  {
    reference: 'general',
    title: 'General',
  },
];
